enum ItemCustomizationType {
  Single = 0,
  Multiple = 1,
  Radio = 2,
  // Checkbox = 3,
}

export default ItemCustomizationType;
